// Edge map colours by DRIVING FUTURE, not by fund (Paolo 2026-10-31): two funds on the same future share a colour,
// so a cluster of one colour reads as one bet. Hues reuse the fund palette's anchor fund per future where one exists
// (NQ = BGA blue, GC = Gold yellow, CL = GGE orange, NIY = Japan pink, SI = Charteris silver, HG = Amati copper);
// ES and RTY have no anchor fund and take lime and teal, both clear of the others on the dark plot.

export const FUTURE_COLOR: Record<string, string> = {
  NQ: '#6ea8df',
  ES: '#a3e635',
  RTY: '#14b8a6',
  CL: '#ff7043',
  GC: '#f6c542',
  SI: '#c0c7d0',
  HG: '#c8794a',
  NIY: '#e879a6',
}

const UNKNOWN_FUTURE_COLOR = '#9e9e9e'

/** The bubble colour for a futures root; an unknown or missing root is neutral grey. */
export function futureColor(future: string | null | undefined): string {
  return (future && FUTURE_COLOR[future.toUpperCase()]) || UNKNOWN_FUTURE_COLOR
}
